// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-icon-delete[data-v-22d34500]{position:absolute;top:15px;left:60px;cursor:pointer;color:#f56c6c}.mar-b-10[data-v-22d34500]{margin-bottom:10px}.pad-10[data-v-22d34500]{padding:10px}", ""]);
// Exports
module.exports = exports;
